import React from "react";
import styled from "styled-components";
import folderIcon from "../assets/explorer_101.ico";

const StyledShorcut = styled.div`
  margin-left: 20px;
  margin-top: 20px;
  display: flex;
  align-items: center;
  cursor: pointer;
  width: fit-content;
`;

function Shortcuts({ openExplorer }) {
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <StyledShorcut onClick={openExplorer}>
        <img
          src={folderIcon}
          alt="Folder"
          style={{ width: "40px", height: "40px" }}
        />{" "}
      </StyledShorcut>
      <div style={{ marginLeft: "15px" }}>Explorer</div>

      {/* <StyledShorcut onClick={openResume}>
        <img
          src={resume}
          alt="Folder"
          style={{ width: "40px", height: "40px" }}
        />{" "}
      </StyledShorcut>
      <div style={{ marginLeft: "15px" }}>Resume</div> */}
    </div>
  );
}

export default Shortcuts;

